import React, { useEffect } from 'react';
import Navbar from '../components/navbar';
/* import BlogDetails from '../blog/blog-details' */
import { useTranslation } from 'react-i18next';
import SimpleFooter from '../components/simpleFooter';
import { HashLink as Link } from 'react-router-hash-link';

const BlogList = () => {

	const { t } = useTranslation();

	useEffect(() => {
		window.scrollTo(0, 0);

		//activate menu
		let menuNode = document.querySelector('a.use-cases')
		if(menuNode) {
			menuNode.classList.add('active')
		}
	}, [])

	const blogCnt = 6;

	// Dynamic Blog Data Loop
	const DataList = (() => {

		let blogArr = []

		for (let i = 1; i <= blogCnt; i++) {

			blogArr.push(
				<div className="col-md-6" key={i}>
					<div className="blog-item" >
						<div className="blog-block">
							<div className="blog-box">
								<div className="overflow-hidden">
									<Link to={{
										pathname: 'blog-details',
										state: {
											blogId: i
										}
									}}>
										<img src={t(`blog image ${i}`)} alt={t(`alt ${i}`)} className="img-fluid" />
									</Link>
								</div>
							</div>
						</div>
						<div className="blog-text">
							<Link to={{
								pathname: 'blog-details',
								state: {
									blogId: i
								}
							}}>
								<h3>{t(`blog title ${i}`)}</h3>
								<p>{t(`blog text ${i}`)}</p>
							</Link>
						</div>
					</div>
				</div>
			)
		}
		return blogArr;
	})()

	return (
		<div>
			<Navbar />
			<div className="page-margin" id="blog">

				{/*breadcrumb start*/}
				<div className="breadcrumb-bg">
					<div className="container">
						<div className="row">
							<div className="col-md-6 col-sm-6 col-text-center d-align-center">
								<h2>{t('use cases')}</h2>
							</div>
							<div className="col-md-6 col-sm-6 col-text-center">
								<nav aria-label="breadcrumb" className="blog-bradcrumb ">
									<ol className="breadcrumb bg-transparent mb-0">
										<li className="breadcrumb-item"><Link smooth to="/#home">{t('home')}</Link></li>
										<li className="breadcrumb-item active"><a href={null}>{t('use cases')}</a></li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>
				{/*breadcrumb end*/}

				{/*blog Section start*/}
				<section>
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div className="row blog-list">
									{DataList}
								</div>
							</div>
						</div>
					</div>
				</section>
				{/*blog Section End*/}


				{/*Footer Section start*/}
				<SimpleFooter />
				{/*Footer Section End*/}
			</div>
		</div>
	);
}

export default BlogList;


// WEBPACK FOOTER //
// ./src/blog/blog-list.js